import React from 'react';
import { FaRocket, FaUsers, FaCode, FaLightbulb, FaShieldAlt } from 'react-icons/fa';
import './AboutUs.css';

const AboutUs = () => {
  const features = [
    {
      icon: <FaRocket />,
      title: 'Fast & Efficient',
      description: 'We deliver projects quickly without compromising on quality or performance.'
    },
    {
      icon: <FaUsers />,
      title: 'Client-Focused',
      description: 'Your success is our priority. We build long-term partnerships, not just projects.'
    },
    {
      icon: <FaCode />,
      title: 'Modern Tech Stack',
      description: 'We use cutting-edge technologies to build scalable, future-proof solutions.'
    },
    {
      icon: <FaLightbulb />,
      title: 'Innovative Solutions',
      description: 'We think outside the box to solve complex problems with elegant solutions.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Quality Assurance',
      description: 'Rigorous testing and quality checks ensure your product is bug-free and reliable.'
    }
  ];

  return (
    <section id="about" className="about-us">
      <div className="about-us-container">
        <div className="about-us-header" data-aos="fade-up">
          <h2 className="section-title">Who We Are</h2>
          <p className="section-subtitle">
            Shawave Technologies is a modern software and product development studio focused on delivering high-performance digital solutions.
          </p>
        </div>
        <div className="about-us-text-section" data-aos="fade-up" data-aos-delay="200">
          <div className="about-us-text">
            <p>
              We blend design, engineering, and strategy to build products that truly help businesses grow.
              Our focus is simple: Build digital experiences that are fast, reliable, and built to scale.
            </p>
            <p>
              We work with startups, enterprises, and founders who want quality engineering without the complexity and inflated pricing.
            </p>
          </div>
        </div>
        <div className="about-us-features-grid" data-aos="fade-up" data-aos-delay="300">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
              data-aos="zoom-in"
              data-aos-delay={400 + index * 100}
            >
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
